import Vue from 'vue'


export function normalizeCopyNotificationsEmails (emails) {
  if (!Array.isArray(emails)) return []

  const seen = new Set()
  const result = []

  emails.forEach(email => {
    const value = String(email || '').trim()
    if (!value) return

    const key = value.toLowerCase()
    if (seen.has(key)) return

    seen.add(key)
    result.push(value)
  })

  return result
}

export function ensureCopyNotificationsEmails (dealer) {
  if (!dealer) return dealer

  if (!Array.isArray(dealer.copyNotificationsEmailAddresses)) {
    Vue.set(dealer, 'copyNotificationsEmailAddresses', [])
  }

  return dealer
}

export function prepareDealerCopyNotifications (dealer) {
  if (!dealer) return dealer

  dealer.copyNotificationsEmailAddresses = normalizeCopyNotificationsEmails(dealer.copyNotificationsEmailAddresses)
  return dealer
}
